import BaseInstitutionEntity from "@/models/Shared/BaseInstitutionEntity";
import Amount from "@/models/Shared/Amount";
import PaymentOrderState from "@/models/Accounts/Shared/PaymentOrders/PaymentOrderState";
import Payment from "@/models/Accounts/Shared/Payments/Payment";
import EntityIdentifier from '@/models/Shared/EntityIdentifier';
import Schedule from '@/models/Shared/Schedule';
import Address from '@/models/Customers/Addresses/Address';

export default class PaymentOrder extends BaseInstitutionEntity {
    accountId: string;
    accountIdentifier: EntityIdentifier;
    accountType: string;
    walletId: string;
    walletIdentifier: EntityIdentifier;
    amount: Amount;
    name: string;
    scheme: string;
    customerAddress: Address;
    scheduled: boolean;
    bulk: boolean;
    schedule: Schedule;
    feeState: string;
    feeId: string;
    feeAmount: Amount;
    metadata: JSON;
    state: PaymentOrderState;
    createdBy: string;
    createdAtUtc: Date;
    updatedAtUtc: Date;
    payments: Payment[];
    expiresAtUtc: Date;
    approvalsRequired: number;
    approval1By: string;
    approval1ByIdentifier: EntityIdentifier;
    approval1AtUtc: Date;
    approval2By: string;
    approval2ByIdentifier: EntityIdentifier;
    approval2AtUtc: Date;
    approval3By: string;
    approval3ByIdentifier: EntityIdentifier;
    approval3AtUtc: Date;
    rejectedBy: string;
    rejectedByIdentifier: EntityIdentifier;
    rejectedAtUtc: Date;
    rejectedReason: string;
    cancelledAtUtc: Date;
    cancelledReason: string;
    submittedAtUtc: Date;
}